import LocalFireDepartmentOutlinedIcon from '@mui/icons-material/LocalFireDepartmentOutlined';

import type { ExportOptionGroup } from '@/features/data-hub/types/exportConfig.types';

import { CsvIcon, ExcelIcon, GxApiIcon, JsonIcon, PowerQueryIcon, PythonIcon } from './icons';

export const mostPopularGroup: ExportOptionGroup = {
  groupName: 'Most Popular',
  GroupIcon: LocalFireDepartmentOutlinedIcon,
  options: [
    {
      id: 'excel',
      displayName: 'Excel',
      label: 'Excel',
      icon: { url: ExcelIcon, size: 14 },
      buttonLabel: 'Download',
      actionHeading: 'Excel',
      exportSubType: 'default',
      buttons: [
        {
          label: 'Download',
          action: 'download'
        }
      ],

      bulletPoints: [
        'Two tabs of data produced',
        'Summary tab for quick analysis, date only',
        'Full data including complete series with delivery timing'
      ]
    },
    {
      id: 'power_query',
      displayName: 'Power Query',
      icon: { url: PowerQueryIcon, size: 16 },
      buttonLabel: 'Copy to clipboard',
      label: 'Excel (PowerQuery)',
      actionHeading: 'PowerQuery (Summary Table)',
      bulletPoints: [
        'Use code in PowerBI or Excel. Data can be refreshed with Data → Refresh',
        'On PC Excel go to Data → Get Data → From Other Sources → Blank Query',
        "Click 'Advanced Editor'; Paste code below; Click 'Done' → 'Close and Load'"
      ],

      disabled: false,
      buttons: [
        {
          label: 'Copy to clipboard',
          action: 'copy'
        },
        {
          label: 'Download',
          action: 'download'
        }
      ],
      showTokenLink: true,
      downloadFileName: 'power_query.m',
      preview: {
        type: 'code',
        language: 'powershell',
        fetchTemplate: true
      }
    },
    {
      id: 'csv',
      displayName: 'CSV',
      label: 'CSV',
      icon: { url: CsvIcon, size: 14 },
      actionHeading: 'CSV',
      disabled: false,
      bulletPoints: [],

      documentationType: 'csv',
      buttons: [
        {
          label: 'Download results',
          action: 'download'
        }
      ],
      downloadFileName: 'export.csv',
      preview: {
        type: 'simple',
        language: 'csv',
        fetchTemplate: true
      }
    },

    {
      id: 'gx_api',
      displayName: 'API',
      icon: { url: GxApiIcon, size: 12 },
      label: 'API',
      buttonLabel: 'Launch',
      actionHeading: 'API',
      documentationType: 'json',

      bulletPoints: ['All symbols for the chosen codes returned'],
      buttons: [
        {
          label: 'Copy to clipboard',
          action: 'copy'
        },
        {
          label: 'Launch',
          action: 'launch'
        }
      ],
      showTokenLink: true,
      preview: {
        type: 'api',
        language: 'http'
      }
    },
    {
      id: 'python',
      displayName: 'Python',
      icon: { url: PythonIcon, size: 14 },
      buttonLabel: 'Copy to clipboard',
      label: 'Python',
      actionHeading: 'Python',
      bulletPoints: [],

      documentationType: 'python',
      buttons: [
        {
          label: 'Copy to clipboard',
          action: 'copy'
        },
        {
          label: 'Download',
          action: 'download'
        }
      ],
      showTokenLink: true,
      downloadFileName: 'gx_export.py',
      preview: {
        type: 'code',
        language: 'python',
        fetchTemplate: true
      }
    },
    {
      id: 'curl',
      displayName: 'curl (json)',
      icon: { url: JsonIcon, size: 14 },
      buttonLabel: 'Copy to clipboard',
      label: 'curl (json)',
      actionHeading: 'curl (json)',
      disabled: false,
      bulletPoints: [],
      documentationType: 'json',
      buttons: [
        {
          label: 'Copy to clipboard',
          action: 'copy'
        },
        {
          label: 'Download results',
          action: 'download'
        }
      ],
      showTokenLink: true,
      downloadFileName: 'export.json',
      preview: {
        type: 'code',
        language: 'bash'
      }
    }
  ]
};
